import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import ToggleSelector from 'modules/core/components/ToggleSelector'

import { newThemeGroupTypeOptions } from 'modules/shift_management/components/ShiftManagement/Content/TableHeader/CommandsFilterBar/ViewSelector/viewTypeOptions'
import type View from 'modules/shift_management/store/internal/models/View'

interface Props {
  view: View
  onGroupChange: (value: string) => void
  onViewChange: (value: string) => void
  readonly?: boolean
}

const ContentOld = ({ view, onViewChange, onGroupChange, readonly }: Props) => {
  return (
    <Box flexDirection="row" gap="s8">
      <ToggleSelector
        value={view.groupType}
        options={newThemeGroupTypeOptions()}
        onChange={onGroupChange}
        readonly={readonly}
      />
    </Box>
  )
}

export default observer(ContentOld)
